import { NgIf } from '@angular/common';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { LanguagesComponent } from '../../../common/languages/languages.component';
import {
  NotificationsComponent,
  ShortcutsComponent,
  ZopBrandingService,
  ZopFullscreenComponent,
  ZopHorizontalNavigationComponent,
  ZopLoadingBarComponent,
  ZopNavigationService,
  ZopVerticalNavigationComponent,
} from '@zopup/zop-ux-core';
import { MediaWatcherService } from '../../../../services/media-watcher/media-watcher.service';
import { MenuType } from '../../../../services/navigation/menu-type.types';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { ZopUxLayoutLibConfig } from '../../../../services/config/config.types';
@Component({
    selector: 'zop-centered-layout',
    templateUrl: './centered.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
        ZopLoadingBarComponent,
        NgIf,
        ZopVerticalNavigationComponent,
        ZopHorizontalNavigationComponent,
        MatButtonModule,
        MatIconModule,
        LanguagesComponent,
        ZopFullscreenComponent,
        ShortcutsComponent,
        NotificationsComponent,
        RouterOutlet,
    ]
})
export class CenteredLayoutComponent implements OnInit, OnDestroy {
    @Input()
    config: ZopUxLayoutLibConfig;

    isScreenSmall: boolean;
    navigation: MenuType;
    navigationAppearance: 'default' | 'centered' = 'centered';
    private _unsubscribeAll: Subject<any> = new Subject<any>();
  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _navigationService: NavigationService,
    private _zopMediaWatcherService: MediaWatcherService,
    private _zopNavigationService: ZopNavigationService,
    public branding: ZopBrandingService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._navigationService.navigation$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((navigation: MenuType) => {
        this.navigation = navigation;
      });

    // Subscribe to media changes
    this._zopMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation =
      this._zopNavigationService.getComponent<ZopVerticalNavigationComponent>(
        name
      );

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
